<div class="container-grid-categories container">
  <a *ngFor="let item of gridCategories.items" [routerLink]="item.link.url">
    <div class="img-container">
      <cx-media [media]="item.media" />
    </div>

    <span *ngIf="item.link.linkName" class="title">
      {{ item.link.linkName }}
    </span>
  </a>
</div>
